import * as React from "react";
import { FormControl, Button, Glyphicon, FormGroup, InputGroup, HelpBlock } from "react-bootstrap";
import { IRccapAdditionalQuestion } from "@nkr/models/index";

interface IProps {
    additionalQuestions: IRccapAdditionalQuestion[],
}

class ViewRccapAdditionalQuestions extends React.Component<IProps, {}> {
    render = () => {
        const list = this.props.additionalQuestions;

        return (
            <>
                {list.map((item, index) =>
                    <div key={index}>
                        <FormGroup key={index} style={{ marginBottom: 0 }}>
                            <InputGroup>
                                <InputGroup.Addon>{index + 1}</InputGroup.Addon>
                                <div className="form-control">{item.question}</div>
                            </InputGroup>
                        </FormGroup>

                        <FormGroup style={{ marginBottom: 0 }}>
                            <InputGroup className="pull-right" style={{ marginTop: 3, width: "95%" }}>
                                <InputGroup.Addon style={{ fontSize: 12 }}>Response</InputGroup.Addon>
                                <div className="form-control">{item.answer}</div>
                            </InputGroup>
                        </FormGroup>

                        <hr style={{ marginTop: 5, marginBottom: 5 }} />
                    </div>
                )}

                {this.props.additionalQuestions.length == 0 && (
                    <div>
                        No additional questions have been entered...
                    </div>
                )}
            </>
        );
    }
}

export default ViewRccapAdditionalQuestions;